import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Channel, ChannelPayload } from "../interfaces";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "./http.service";

@Injectable({ providedIn: "root" })
export class ChannelService {
  private channel$: BehaviorSubject<Channel>;
  private channel: Channel = <Channel>{};

  constructor(private http: HttpClient, private httpService: HttpService) {
    this.channel$ = new BehaviorSubject(this.channel);
  }

  getChannel$(): Observable<Channel> {
    return this.channel$.asObservable();
  }

  getChannel(): Channel {
    return this.channel;
  }

  setChannel$(channel: Channel): void {
    this.channel$.next(channel);
  }

  setChannel(channel: Channel): void {
    this.channel = channel;
  }

  createChannel(channelPayload: ChannelPayload): Observable<Channel> {
    return this.http.post<Channel>(
      `${environment.apiBaseUrl}/channel}`,
      channelPayload,
    );
  }

  getChannelById(channelId: string): Observable<Channel> {
    return this.http.get<Channel>(
      `${environment.apiBaseUrl}/channel/${channelId}`,
    );
  }

  updateChannel(
    channelId: string,
    partialChannel: Partial<Channel>,
  ): Observable<Channel> {
    return this.http.patch<Channel>(
      `${environment.apiBaseUrl}/channel/${channelId}`,
      partialChannel,
    );
  }

  deleteChannel(channelId: string): Observable<Channel> {
    return this.http.delete<Channel>(
      `${environment.apiBaseUrl}/channel/${channelId}`,
    );
  }

  getChannelsByAccountId(accountId: string): Observable<Channel[]> {
    return this.http.get<Channel[]>(
      `${environment.apiBaseUrl}/channels/${accountId}`,
      this.httpService.getOptions()
    );
  }
}
